import {Container, Grid, MenuItem, Paper, TableBody, TableHead, TextField} from "@mui/material";
import {
    StyledTable, StyledTableBodyRow,
    StyledTableCell, StyledTableCellHeader, StyledTableContainer,
    StyledTableHeadRow
} from "../../styles/MyStyles";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {GetEnumMenuItems, GetEnumValueName} from "../../logic/EnumHelper";
import dayjs from "dayjs";
import {GetCookieInfo} from "../../logic/CookieManager";
import {GetClients} from "../../logic/DataProvider";
import {GetClientViewName} from "../../logic/ClientNameHelper";
import {SortTickets} from "../../logic/TicketHelper";
import moment from "moment/moment";
import * as MyStyles from "../../styles/MyStyles";


const ManagerTicketsPage = () => {
    const navigate = useNavigate();
    const [tickets, setTickets] = useState([]);
    const [authorIds, setAuthorIds] = useState([]);

    const [clients, setClients] = useState([]);

    const [searchQuery, setSearchQuery] = useState('');
    const [selectedClient, setSelectedClient] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');

    useEffect(() => {
        GetClients().then((clients) => setClients(clients));
        fetchTickets();
    }, []);

    const fetchTickets = async () => {
        try {
            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_TICKETING_URL}`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify({})
                }
            );
            if (response.ok) {
                const data = await response.json();
                console.log(data.data);

                SortTickets(data.data);

                setTickets(data.data);

                handleAuthorIds(data.data);
            } else {
                console.log('Fetch tickets failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleAuthorIds = (tickets) => {
        let authors = [];
        tickets.forEach((ticket) => {
            let authorId = ticket.authorId;

            if (authors.indexOf(authorId) === -1) {
                authors.push(authorId);
            }
        });
        setAuthorIds(authors);
    };

    const onTicketClick = (id) => {
        navigate(`${id}`);
    };

    const getClientsMenuItems = () => {
        let items = [<MenuItem key="" value="">All</MenuItem>];
        if (clients) {
            clients.forEach((elem) => {

                if (authorIds.indexOf(elem.id) === -1) {
                    return;
                }

                items.push(
                    <MenuItem key={elem.id} value={elem.id}>
                        {GetClientViewName(elem)}
                    </MenuItem>
                );
            });
        }
        return items;
    };

    const handleSearchQueryChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const filteredTickets = tickets ? tickets.filter(
        (ticket) =>
            ticket.title.toLowerCase().includes(searchQuery.toLowerCase()) &&
            (selectedClient === '' || ticket.authorId === parseInt(selectedClient)) &&
            (selectedType === '' || ticket.type === parseInt(selectedType)) &&
            (selectedStatus === '' || ticket.status === parseInt(selectedStatus))
    ) : [];

    const handleClientFilter = (event) => {
        setSelectedClient(event.target.value);
    };
    const handleTypeFilter = (event) => {
        setSelectedType(event.target.value);
    };
    const handleStatusFilter = (event) => {
        setSelectedStatus(event.target.value);
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <TextField
                        label="Search"
                        value={searchQuery}
                        onChange={handleSearchQueryChange}
                        margin="normal"
                        size="small"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField
                        select
                        label="Client"
                        value={selectedClient}
                        onChange={handleClientFilter}
                        margin="normal"
                        size="small"
                        fullWidth
                    >
                        {getClientsMenuItems()}
                    </TextField>
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField
                        select
                        label="Type"
                        value={selectedType}
                        onChange={handleTypeFilter}
                        margin="normal"
                        size="small"
                        fullWidth
                    >
                        {GetEnumMenuItems('ticketType', true)}
                    </TextField>
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField
                        select
                        label="Status"
                        value={selectedStatus}
                        onChange={handleStatusFilter}
                        margin="normal"
                        size="small"
                        fullWidth
                    >
                        {GetEnumMenuItems('ticketStatus', true)}
                    </TextField>
                </Grid>
            </Grid>
            <StyledTableContainer component={Paper}>
                <StyledTable>
                    <TableHead>
                        <StyledTableHeadRow>
                            <StyledTableCellHeader columncount={6}>Last Activity</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={6}>Author</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={6}>Open Date</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={6}>Title</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={6}>Type</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={6}>Status</StyledTableCellHeader>
                        </StyledTableHeadRow>
                    </TableHead>
                    <TableBody>
                        {filteredTickets && filteredTickets.map((ticket) => (
                            <StyledTableBodyRow key={ticket.id} onClick={() => onTicketClick(ticket.id)}>
                                <StyledTableCell>{moment(ticket.lastActivityDate).fromNow()}</StyledTableCell>
                                <StyledTableCell>{GetClientViewName(clients.find(e => e.id === ticket.authorId))}</StyledTableCell>
                                <StyledTableCell>{dayjs(ticket.openDate).format(MyStyles.DateFormat)}</StyledTableCell>
                                <StyledTableCell>{ticket.title}</StyledTableCell>
                                <StyledTableCell>{GetEnumValueName('ticketType', ticket.type)}</StyledTableCell>
                                <StyledTableCell>{GetEnumValueName('ticketStatus', ticket.status)}</StyledTableCell>
                            </StyledTableBodyRow>
                        ))}
                    </TableBody>
                </StyledTable>
            </StyledTableContainer>
        </Container>
    );
};
export default ManagerTicketsPage;